/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */
import tinycolor from 'tinycolor2';

import { constants as config } from '@config';

import ColorSelector from '../../colors/color-selector';

import DrawingMenuItems from './drawer/drawing-menu-items';
import FramesMenuItems from './drawer/frame-menu-items';
import ShapeMenuItems from './drawer/shape-menu-items';
import SimpleTableMenuItems from './drawer/simple-table-menu-items';
import TextMenuItems from './drawer/simple-text-menu-items';

module.exports = Backbone.View.extend({
  hasLibrary: null,

  initialize: function () {
    this.tool = INKIVE.Tool.getInstance();
    this.editor = this.tool.editor;
    INKIVE.UserInfoFactory.get().then(_.bind(function (userInfo) {
      this.hasLibrary = _(userInfo.roles).contains('ROLE_LIBRARY');
    }, this));

    _.bindAll(this, 'initSliderElement', 'getElemsForStrokeChange', 'updateFontRelatedMenu', 'highlightAppliedOptions',
      'drawStrokeDropdownItems', 'drawColors', 'drawColor', 'scrollHandler');
  },

  initSliderElement: function ($elem, id, value, min, max, title, options) {
    let $p = $elem.find('.ui-dropdown-items');
    const currentValue = Array.isArray(value) ? 0 : value;

    if (!$p.length) {
      $p = $elem;
      $p.append('<div class="slider-title"><small style="line-height: 10px; display: flex;">' +
      (title || $p.attr('data-title')) + '</small><div>');

      if (options?.tooltip) {
        const icon = `<icon data-popover="tooltip" data-original-title="${options.tooltip}" data-title="${options.tooltip}"><svg><use xlink:href="#alert-info"></use></svg></icon>`;
        $p.find('div.slider-title').append(icon);
        INKIVE.Helpers.initTooltips($p.find('div.slider-title'), { placement: 'top' });
      }

      $p.tooltip('disable');
      $p.addClass('nohover');
    } else if (title) {
      $elem.find('.ui-dropdown-items')
        .append(`<small class="dropdown-tooltip-title">${title}</small>`);
    }

    $p.append(`
      <span id="sliderWrapper">
        <div class="slider"></div>
      </span>
      <input type="text" id="${id}" value="${currentValue}"/>
    `);

    $p.find('#' + id).on('click', function () {
      $(this).select();
    });

    const slider = $p.find('.slider').slider({
      max,
      min,
      value: currentValue,
      slide: function (event, ui) {
        const min = slider.slider('option', 'min');
        const max = slider.slider('option', 'max');

        $p.find('#' + id).val(ui.value);
        $p.find('#' + id).trigger('change', [ui.value]);
        $p.find('div.ui-widget').css('width', `${(ui.value - min) / (max - min) * 100}%`);
      },
      start: function (event, ui) {
        $p.find('#' + id).trigger('start', [ui.value]);
      },
      stop: function (event, ui) {
        $p.find('#' + id).trigger('stop', [ui.value]);
      }
    });

    $p.find('div.ui-widget').css('width', `${(currentValue - min) / (max - min) * 100}%`);

    const handleInputChange = function (event) {
      event.preventDefault();

      const roundedValue = +parseFloat(this.value).toFixed(1) || 0;
      if (roundedValue > max) {
        this.value = max;
      } else if (roundedValue < min) {
        this.value = min;
      } else {
        this.value = roundedValue;
      }

      try {
        const min = slider.slider('option', 'min');
        const max = slider.slider('option', 'max');

        slider.slider('option', 'value', +parseFloat(this.value).toFixed(1));
        $elem.trigger('start', [+parseFloat(this.value).toFixed(1)]);
        $elem.trigger('change', [+parseFloat(this.value).toFixed(1)]);
        $elem.trigger('stop', [+parseFloat(this.value).toFixed(1)]);
        $p.find('div.ui-widget').css('width', `${(+parseFloat(this.value).toFixed(1) - min) / (max - min) * 100}%`);
      } catch (e) {}
    };

    $p.get(0) && $p.get(0).querySelector('#' + id).addEventListener('change', handleInputChange);

    slider.slider('float');
  },

  getElemsForStrokeChange: function (elem) {
    const elems = [];

    function addNonG (e) {
      if (e.nodeName !== 'g') {
        elems.push(e);
      }
    }

    if (elem) {
      if ($(elem).hasClass('textarea')) {
        elems.push(elem);
      } else if (elem.tagName === 'g') {
        svgedit.utilities.walkTree(elem, addNonG);
      } else {
        elems.push(elem);
      }
    }

    return elems;
  },

  updateFontRelatedMenu: function (popup) {
    if (!(popup.button('on_fontfamily').length || popup.button('on_finishTextEditing').length)) {
      return;
    }

    const textAttr = new INKIVE.Text.Textarea().setDOM(popup.element());
    if (!textAttr) return;

    const canvas = INKIVE.Tool.getInstance().editor.canvas;
    const isTyping = canvas.getMode() === 'textedit';

    // const font = styles.font_family;
    const font = textAttr.text.font_family;
    let fontData = INKIVE.FontsFactory.get(font, textAttr.text.font_weight);

    // special case if font is not defined
    if (!fontData) {
      INKIVE.FontsFactory.addFontToList(font);
      fontData = INKIVE.FontsFactory.get(font, textAttr.text.font_weight);
    }

    const fontSupport = fontData.support;
    const $b = popup.button('on_set-bold');
    const $bp = popup.li('on_set-bold').addClass('semidisabled');
    const $i = popup.button('on_set-italic');
    const $ip = popup.li('on_set-italic').addClass('semidisabled');
    const $u = popup.button('on_set-underline');
    const $up = popup.li('on_set-underline').addClass('semidisabled');
    const fontSizeInput = popup.button('on_fontsize')[0]?.querySelector('input');
    if (textAttr.text.font_size && fontSizeInput?.value) fontSizeInput.value = Number(textAttr.text.font_size);

    const button = popup.button('on_heading')[0];
    const headingSpan = button && button.querySelector('span');
    if (textAttr.heading && headingSpan) headingSpan.textContent = 'Heading ' + Number(textAttr.heading);

    const fontWeight = popup.$element.find('.text').attr('font-weight');

    const supportsBold = fontSupport.b || fontSupport.bi || !!fontWeight;
    const supportsItalic = fontSupport.i || fontSupport.bi;

    if (!isTyping) {
      _.isNumber(fontWeight) && fontWeight > 400 && $b.addClass('applied');
    }

    (supportsBold || $b.hasClass('applied')) && $b.click();
    (supportsItalic || $i.hasClass('applied')) && $i.click();
    textAttr.text.letter_spacing && $u.hasClass('applied') && $u.click();

    supportsBold && $bp.removeClass('semidisabled');
    supportsItalic && $ip.removeClass('semidisabled');

    if (fontSupport.b) {
      $b.attr('data-original-title', $b.attr('data-title'));
    } else {
      $b.attr('data-original-title', INKIVE.TranslateHelper.translate('modal.alert.font_no_bold'));
    }

    if (fontSupport.i) {
      $i.attr('data-original-title', $i.attr('data-title'));
    } else {
      $i.attr('data-original-title', INKIVE.TranslateHelper.translate('modal.alert.font_no_italic'));
    }

    if ($b.hasClass('applied') && !fontSupport.bi) {
      $ip.addClass('semidisabled');
      $i.hasClass('applied') && $i.click();
      $i.attr('data-original-title', INKIVE.TranslateHelper.translate('modal.alert.font_no_bolditalic'));
    } else if ($b.hasClass('applied') && fontSupport.bi) {
      $i.attr('data-original-title', $i.attr('data-title'));
    }

    if ($i.hasClass('applied') && !fontSupport.bi) {
      $bp.addClass('semidisabled');
      $b.hasClass('applied') && $b.click();
      $b.attr('data-original-title', INKIVE.TranslateHelper.translate('modal.alert.font_no_bolditalic'));
    } else if ($i.hasClass('applied') && fontSupport.bi) {
      $b.attr('data-original-title', $b.attr('data-title'));
    }

    $up.removeClass('semidisabled');
    $u.attr('data-original-title', $u.attr('data-title'));

    if (_.contains(textAttr.text.textContent, '\n')) {
      popup.button('on_set-auto-adjustable').addClass('disabled');
    }

    const textAlignButton = popup.button('on_text-align')[0];
    const handleRtl = textAlignButton && textAttr.text.direction === 'rtl' && !textAlignButton.classList.contains('rtl-applied');
    const isJapanese = textAlignButton && textAttr.text.isJapanese;

    if (handleRtl || isJapanese) INKIVE.Text.Helpers.handleAlignmentIcon(handleRtl, false, textAlignButton, isJapanese);

    this.toggleTextSpacingForJustification(popup, !textAttr.text.text_anchor.includes('justify'));
  },

  toggleTextSpacingForJustification: function (popup, show) {
    const autoAdjustableButton = popup.button('on_set-auto-adjustable');

    show = show && (!autoAdjustableButton.length || autoAdjustableButton.is(':not(.applied)'));

    popup.button('on_set-char-spacing').parent().toggle(show);
  },

  toggleBackgroundRemovalIcon: function () {
    const backgroundRemovalIcon = document.querySelector('[data-action="on_bgRemoval"]');
    if (!backgroundRemovalIcon) return;

    backgroundRemovalIcon.classList.remove('disabled');
  },

  highlightAppliedOptions: function (buttonSelect, $elem) {
    if ($elem.is('#clip_bleed_area')) {
      return;
    }
    toggleAppliedClass('on_unlinkElement', isLinked());

    toggleAppliedClass('on_unlockImage', true);
    toggleAppliedClass('on_flipImageH', isFlippedImage('horizontal'));
    toggleAppliedClass('on_flipImageV', isFlippedImage('vertical'));
    toggleAppliedClass('on_flipBackgroundH', isFlippedBackground('horizontal'));
    toggleAppliedClass('on_flipBackgroundV', isFlippedBackground('vertical'));
    toggleAppliedClass('on_imageFilter', isFiltred());

    toggleAppliedClass('on_unlockElement', true);

    toggleAppliedClass('on_opacity', isTranparent());
    toggleAppliedClass('on_stroke', hasStroke());

    const element = INKIVE.DesignFacade.get($elem[0].id);

    if (element && element.background_removed) {
      const selectedButtons = buttonSelect('on_bgRemoval');
      const target = selectedButtons && selectedButtons[0];
      if (target) target.classList.add('disabled');
    }

    const popup = $elem.popupmenu()[0];
    const isRtl = $(popup.element()).find('.text').is('[direction="rtl"]');
    const alignJustifyStartButton = popup.button('on_set-align-justify_start');
    const alignJustifyMiddleButton = popup.button('on_set-align-justify_middle');
    const alignJustifyEndButton = popup.button('on_set-align-justify_end');
    const alignJustifyAllButton = popup.button('on_set-align-justify_all');

    const buttonAvailable = alignJustifyStartButton.length > 0 &&
      alignJustifyMiddleButton.length > 0 &&
      alignJustifyEndButton.length > 0 &&
      alignJustifyAllButton.length > 0;

    let showTextSpacing = !isRtl;
    if (showTextSpacing && buttonAvailable) {
      showTextSpacing = alignJustifyStartButton.is(':not(.applied)') &&
        alignJustifyMiddleButton.is(':not(.applied)') &&
        alignJustifyEndButton.is(':not(.applied)') &&
        alignJustifyAllButton.is(':not(.applied)');
    }
    this.toggleTextSpacingForJustification(popup, showTextSpacing);

    function isFiltred () {
      return $elem.attr('filter') !== null;
    }

    function isTranparent () {
      return $elem.attr('opacity') !== null && $elem.attr('opacity') < 1;
    }

    function isFlippedImage (orientation) {
      const image = INKIVE.DesignFacade.get($elem.attr('id'));
      if (image && image.flipped) {
        return image.flipped[orientation];
      } else {
        return false;
      }
    }

    function isFlippedBackground (orientation) {
      const image = INKIVE.DesignFacade.get($elem.attr('id'));
      if (image && image.flipped) {
        return image.flipped[orientation];
      } else {
        return false;
      }
    }

    function isLinked () {
      return $elem.is('a') || $elem.parent().is('a');
    }

    function hasStroke () {
      return $elem.attr('stroke-width') > 0;
    }

    function toggleAppliedClass (element, value) {
      buttonSelect(element).toggleClass('applied', value);
    }
  },

  drawStrokeDropdownItems: function ($elem) {
    const $strokeDropdownItems = $elem.popupmenu('button', 'on_stroke')
      .find('.ui-dropdown-items');

    this.initSliderElement(
      $elem.popupmenu('button', 'on_stroke'),
      'strokeWidth', this.editor.getStrokeWidth(), 0, 20
    );

    drawListItems(this.editor, $elem[0]);
    setInitialAppliedLine($elem[0]);

    function drawListItems (editor, elem) {
      const dashArrays = ['5, 5', '5, 10', '10, 5', '5, 1', '1, 5', '0.9', '15, 10, 5, 10', '5, 5, 1, 5'];
      const html = INKIVE.TemplatesHelper('popupmenu_stroke_dasharray', {
        dashArrays,
        width: editor.getStrokeWidth()
      });

      $strokeDropdownItems.append(html).find('ul.stroke-dasharray li').on('click', function () {
        const $item = $(this);
        const dasharray = $item.find('svg line').attr('stroke-dasharray');
        const elementData = INKIVE.DesignFacade.get(elem.getAttribute('id'));
        const shapeData = { stroke: { dasharray } };

        if (_.contains(['shape', 'text'], elementData.type)) {
          INKIVE.DesignFacade.set(shapeData);
        } else {
          const shapes = [];
          _.each(elementData.shapes, function (shape, index) {
            shapes[index] = shapeData;
          });

          INKIVE.DesignFacade.set({ shapes });
        }

        $item.addClass('applied').siblings('.applied').removeClass('applied');
      });

      $strokeDropdownItems.find('.stroke-dasharray').toggle(editor.getStrokeWidth() > 0);
    }

    function setInitialAppliedLine (elem) {
      const dasharray = getTrimmedArray(elem);
      const $lines = $strokeDropdownItems.find('li svg line');

      _.any($lines, function (line) {
        const values = getTrimmedArray(line);
        if (isAppliedDasharray(values)) {
          $(line).closest('li').addClass('applied');
          return true;
        }
      }) || setDefaultAppliedLine();

      function setDefaultAppliedLine () {
        $strokeDropdownItems.find('ul.stroke-dasharray li')
          .first().addClass('applied');
      }

      function getTrimmedArray (elem) {
        let value = elem.getAttribute('stroke-dasharray');

        if (!value) {
          value = $(elem).find('[stroke-dasharray]').attr('stroke-dasharray');
        }

        return _.map(value ? value + ''.split(',') : [], function (val) {
          return val.trim();
        });
      }

      function isAppliedDasharray (da) {
        if (!da && !dasharray) return true;
        if (!da || !dasharray) return false;
        if (da.length !== dasharray.length) return false;

        return _.all(da, function (val, index) {
          return val === dasharray[index];
        });
      }
    }
  },

  /**
   *
   * @param {HTMLElement} elem
   * @param {number} index
   * @param {HTMLElement} button
   * @param {(function(string): void) | undefined } onColorSelect
   */
  drawColor: function (elem, index, button, onColorSelect) {
    const canvas = INKIVE.Tool.getInstance().editor.canvas;
    $(button).append('<div class="colorLineWrapper"></div>');
    const $button = $(button).closest('.btn-onmenu');
    let type = $button.attr('type');
    let fillGroup;
    if (type.match(/set_/)) {
      fillGroup = type.split('_')[1];
      type = 'fill';
    }
    const isFill = type === 'fill';
    const isStrokeType = type === 'stroke';
    const getColor = () => {
      if (isFill && fillGroup) {
        const colors = this.getFillColors($(elem));

        return colors.find((color) => color.colorGroup === fillGroup)?.color;
      }

      return INKIVE.Helpers.getColor(elem, type);
    };
    const color = getColor();

    function updatetooltip (color) {
      let colorAsString;
      const isNone = !color || color.toUpperCase() === 'NONE';

      if (isNone) {
        colorAsString = 'None';
      } else {
        const isDesygnerGradient = color.match(/url\(#gradient-\d+\)/);
        colorAsString = isDesygnerGradient ? 'Gradient' : color.toUpperCase();
      }
      const translationKey = 'popupmenu.tooltip.' + type + '_color';
      const tooltipTitle = INKIVE.TranslateHelper.translate(translationKey, { color: colorAsString });

      if (color?.toLowerCase() === 'none') {
        $button.find('i').css('color', '#FFFFFF');
        $button.find('i').first().css({
          color: 'rgba(0,0,0,0)',
          'background-image': 'linear-gradient(45deg, #777 25%, transparent 25%, transparent 75%, #777 75%, #777), linear-gradient(45deg, #777 25%, transparent 25%, transparent 75%, #777 75%, #777)',
          'background-size': '10px 10px',
          'background-position': '0 0, 5px 5px'
        });
        $button.find('svg').css('stroke', '#D1D3D6');
        $button.find('svg').css('fill', '#FFFFFF');
      } else if (color === '#FFFFFF') {
        $button.find('i').css('color', '#FFFFFF');
        $button.find('i').first().css({
          'background-image': '',
          'background-size': '',
          'background-position': ''
        });
        $button.find('svg').css('stroke', '#D1D3D6');
        $button.find('svg').css('fill', '#FFFFFF');
      } else {
        $button.find('svg').css('fill', color);
        $button.find('i').first().css({
          'background-image': '',
          'background-size': '',
          'background-position': ''
        });
        $button.find('svg').css('stroke', 'none');
        $button.find('i').css('color', color);
      }

      if (type === 'background') {
        isNone && $button[0].querySelector('i').classList.add('empty-background-icon');
      } else {
        $button.attr('data-original-title', tooltipTitle);
      }
    }

    updatetooltip(color);

    $button.append('<input type="hidden" name="hex" value="' + tinycolor(color).toHexString() + '"/>');

    const colorSelector = new ColorSelector();

    function handleStyling (textarea, range, options) {
      const attribute = config.smartAssets.attributes.definedAsset;
      const settings = { shouldRemoveOverlappedStyles: true };

      if (textarea.text.isSegmentSelected(range.start, range.end, attribute)) {
        const currentSmartAsset = textarea.text.getPartialStyling(range.start, range.end, attribute);

        if (currentSmartAsset && options) {
          const newValue = options + ',' + currentSmartAsset;
          textarea.text.setPartialStyling(range.start, range.end, attribute, newValue, settings);
          return;
        }
      }

      if (options) {
        textarea.text.setPartialStyling(range.start, range.end, attribute, options, settings);
      } else {
        textarea.text.removeSpecificPartialStyling(range.start, range.end, attribute, undefined, settings);
      }
    }

    colorSelector.initialize(this.hasLibrary, $(elem), type).then(function () {
      colorSelector.favColors($(button), function (item, extraData) {
        const hex = $(item).data('color');
        const smartAsset = $(item).data('smartAsset') || null;

        updatetooltip(hex);
        if (onColorSelect) {
          onColorSelect(hex);
          return;
        }
        // special case for partial text edit
        if (canvas.getMode() === 'textedit') {
          const textarea = new INKIVE.Text.Textarea().setDOM(elem, false);
          const range = canvas.runExtensions('selectionRange', {});
          smartAsset && handleStyling(textarea, range, smartAsset);
          textarea.text.setPartialStyling(range.start, range.end, type, hex);
          textarea.render(canvas);
          INKIVE.DesignFacade.trigger('text.update');
        } else {
          const selectedItems = canvas.getSelectedElems();

          for (let i = 0; i < selectedItems.length; i++) {
            const elementData = INKIVE.DesignFacade.get(selectedItems[i].getAttribute('id'));
            const shapes = {};
            const shapeData = {
              smart_asset: smartAsset,
              [type]: {
                color: hex,
                colorGroup: fillGroup,
                previousColor: getColor()
              },
              skipDefinedAsset: type
            };

            switch (elementData.type) {
              case 'table':
                if (type === 'cell_lines') {
                  shapeData[type].where = extraData.where;
                }
                INKIVE.DesignFacade.set(shapeData);
                break;

              case 'text':
                if (elementData.id === selectedItems[i].id) {
                  INKIVE.DesignFacade.set(isFill ? { color: hex, smart_asset: smartAsset } : shapeData);
                } else { // Is text inside a sticker
                  INKIVE.DesignFacade.set(elementData.id, isFill ? { color: hex, smart_asset: smartAsset } : shapeData);
                }
                break;

              case 'shape':
                INKIVE.DesignFacade.set(shapeData);
                break;

              case 'logo':
              case 'icon':
              case 'qrcode':
              case 'sticker':
                if (isStrokeType && elementData.shapes) {
                  for (let i = 0; i < Object.entries(elementData.shapes).length; i++) {
                    const shape = elementData.shapes[i];
                    if ((shape.fill && Object.prototype.hasOwnProperty.call(shape.fill, 'color')) || isStrokeType) {
                      shapes[i] = shapeData;
                    }
                  }
                } else {
                  const index = $(item).closest('.btn-onmenu').attr('type').split('_')[1];
                  const shape = elementData.shapes && elementData.shapes[index];

                  if (!shape) break;

                  if ((shape.fill && Object.prototype.hasOwnProperty.call(shape.fill, 'color')) || isStrokeType) {
                    shapes[index] = shapeData;
                  }
                }

                INKIVE.DesignFacade.set({ shapes, smart_asset: smartAsset });
                break;

              case 'background':
                INKIVE.DesignFacade.set('background', { color: hex, smart_asset: smartAsset });
                canvas.runExtensions('showBackgroundPopupMenu', {});
                break;
            }
          }
          isStrokeType && $(elem).popupmenu('li', 'on_stroke').toggle(hex && hex !== 'none');
        }
      });
    });

    if (!color) {
      isStrokeType && $(elem).popupmenu('li', 'on_stroke').hide();
    }
  },

  drawColors: function ($elem, buttonSelect) {
    const colorsLimit = 10;
    const colors = this.getFillColors($elem).slice(0, colorsLimit);
    colors.forEach((color, index) => $elem.popupmenu(
      'appendBeforeSelector',
      '[data-action="colormap-circle"][type="fill"]',
      'FILL_COLOR',
      { type: 'set_' + color.colorGroup }
    ));

    $(buttonSelect('colormap-circle')).filter('[type="fill"]').last().parent().remove();
  },

  scrollHandler: function (event) {
    const $elementPopupmenu = $('.element-popupmenu.menu');
    const isLeft = $(event.target).parents().andSelf().is('.scroll-handler-left');
    const $leftArrow = $elementPopupmenu.siblings('.scroll-handler-left').hide();
    const $rightArrow = $elementPopupmenu.siblings('.scroll-handler-right').hide();
    const currentLeft = parseInt($elementPopupmenu.css('left'));
    const width = $elementPopupmenu.parent().width() - $leftArrow.width() - $rightArrow.width();
    const start = 0;
    const end = $elementPopupmenu.parent().width() - $elementPopupmenu.width();
    let leftValue;

    if (isLeft) {
      leftValue = currentLeft + width < start ? currentLeft + width : start;
    } else {
      leftValue = currentLeft - width > end ? currentLeft - width : end;
    }

    $elementPopupmenu.animate({
      left: leftValue
    }, 500, _.bind(function () {
      this.editor.canvas.runExtensions('browserResize', {
        skipScroll: true,
        showBoth: leftValue < start && leftValue > end,
        $handler: (isLeft ? $rightArrow : $leftArrow)
      });
    }, this));
  },

  getDrawingButtons: function ($container) {
    this.drawing = new DrawingMenuItems({ el: $container });
  },

  getFillColors: function ($container) {
    let shapes = INKIVE.DesignFacade.get($container.attr('id'), 'shapes');
    shapes = INKIVE.DesignFacade.setters.sticker.updateMissingColorGroup($container[0], { shapes });
    if (!shapes) return [];

    return Object.values(Object.values(shapes).map(shape => shape.fill)
      .reduce((colors, fill) => {
        if (!fill.color) {
          return colors;
        }

        if (!colors[fill.colorGroup]) {
          colors[fill.colorGroup] = fill;
        }

        return colors;
      }, {}));
  },

  getFrameButtons: function ($container) {
    this.frames = new FramesMenuItems({ el: $container });
  },

  getTextButtons: function ($container) {
    this.texts = new TextMenuItems({ el: $container });
  },

  getTableButtons: function ($container) {
    this.tables = new SimpleTableMenuItems($container.get(0));
  },

  getShapeButtons: function ($container) {
    this.shapes = new ShapeMenuItems({ el: $container });
  },

  handleAlignmentOptions: function (alignmentMenu) {
    if (!alignmentMenu) return;

    const sliderContainer = document.createElement('div');
    const title = INKIVE.TranslateHelper.translate('popupmenu.common.page_margin');
    const tooltipTitle = INKIVE.TranslateHelper.translate('popupmenu.tooltip.page_margin');
    sliderContainer.classList.add('slider-container');
    alignmentMenu.append(sliderContainer);
    this.initSliderElement($(sliderContainer), 'margin', 5, 0, 30, title, { tooltip: tooltipTitle });
  },

  isAddToLibraryAllowed: function (elem) {
    const $elem = $(elem);
    if ($elem.attr('from-library') === 'true') return false;
    let canAccess = INKIVE.PopupMenuDefault.canAccessLibrary ||
      INKIVE.PopupMenuDefault.canAccessWorkspaceLibrary;

    if (canAccess && $elem.is('.group')) {
      $elem.find('>').each(function () {
        if (!$(this).is('line, path, rect, circle, ellipse, .sticker, .logo, .icon, .textarea')) {
          canAccess = false;
        }
      });
    }

    if (canAccess) {
      if (INKIVE.C.USER.kw_uid && INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.DESIGN) {
        canAccess = false;
      }
    }

    if ($elem.data('external_source') === INKIVE.C.SHUTTERSTOCK) {
      canAccess = false;
    }

    return canAccess;
  }
});
